const md5 = require("md5");

class Authenticator {
  constructor(emitter, firebase) {
    this.token = null;
    this.user = null;
    this.error = null;
    this.emitter = emitter;
    this.firebase = firebase;
  }

  authenticate() {
    this.firebase.auth().onAuthStateChanged(user => this.handle(user));
  }

  signOut() {
    this.firebase
      .auth()
      .signOut()
      .catch(error => this.handle(null, error));
  }

  handle(user, error) {
    if (user && this.isAuthorizedEmails(user.email)) {
      if (!user.emailVerified) {
        this.token = null;
        this.user = null;
        this.emitter.emit("auth.changed", this);
        return;
      }
      this.firebase
        .auth()
        .currentUser.getIdToken(true)
        .then(token => {
          this.user = user;
          this.token = token;
          this.emitter.emit("auth.changed", this);
        })
        .catch(() => {
          this.token = null;
          this.user = null;
          this.emitter.emit("auth.changed", this);
        });
    } else {
      this.token = null;
      this.user = null;
      this.emitter.emit("auth.changed", this);
    }
    if (error) {
      this.error = error;
    }
  }

  sendEmailVerification() {
    return this.firebase.auth().currentUser.sendEmailVerification();
  }

  signInWithEmailAndPassword(email, password) {
    return new Promise((resolve, reject) => {
      this.firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(result => resolve(result.user))
        .catch(reject);
    });
  }

  isAuthorizedEmails(email) {
    return ["fd44e924e265e70bb985211c317b22bb"].indexOf(md5(email)) >= 0;
  }
}

export default {
  install(Vue) {
    Vue.prototype.$auth = new Authenticator(
      Vue.prototype.$emitter,
      Vue.prototype.$firebase
    );
  }
};
